import { Tooltip, TooltipContent, TooltipTrigger } from '@invent/wl-ui-kit-next/ui';
import * as React from 'react';

/**
 * Why a control is off, kept off the screen (SR-525, C3; the UI copy rule): the disabled control
 * inside a focusable box whose tooltip says the reason, and the same words in a hidden element the
 * control's `aria-describedby` names by `id`, so a screen reader hears them with it. A disabled
 * button takes neither hover nor focus, so the box carries both. A reason the reader must not miss
 * — a permission not held (`NotPermitted`) — stays on the screen instead.
 */
export function OffReason({
  id,
  reason,
  children
}: {
  /** The hidden element's id, which the control's `aria-describedby` names. */
  id: string;
  /** Null while the control is on: it is drawn bare. */
  reason: Nullable<string>;
  children: React.ReactNode;
}) {
  if (!reason) return <>{children}</>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0} className="inline-flex rounded-md outline-none focus-visible:ring-2 focus-visible:ring-ring" data-off-reason="">
          {children}
          <span id={id} className="sr-only">
            {reason}
          </span>
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">{reason}</TooltipContent>
    </Tooltip>
  );
}
